<script>
import NextButton from 'dashboard/components-next/button/Button.vue';
import Avatar from 'next/avatar/Avatar.vue';
import { formatDistanceToNow } from 'date-fns';

export default {
  components: {
    NextButton,
    Avatar,
  },
  props: {
    token: {
      type: Object,
      required: true,
    },
  },
  emits: ['delete'],
  computed: {
    statusClass() {
      switch (this.token.status) {
        case 'active':
          return 'bg-g-50 text-g-800 dark:bg-g-800 dark:text-g-200';
        case 'expired':
          return 'bg-y-50 text-y-800 dark:bg-y-800 dark:text-y-200';
        case 'revoked':
          return 'bg-r-50 text-r-800 dark:bg-r-800 dark:text-r-200';
        default:
          return 'bg-n-50 text-n-800';
      }
    },
    statusLabel() {
      return this.$t(
        `KAPTION_ACCESS_TOKENS.STATUS.${this.token.status.toUpperCase()}`
      );
    },
    lastUsedText() {
      if (!this.token.last_used_at) {
        return this.$t('KAPTION_ACCESS_TOKENS.LIST.NEVER_USED');
      }
      return formatDistanceToNow(new Date(this.token.last_used_at), {
        addSuffix: true,
      });
    },
    tokenPrefix() {
      return this.token.token_prefix
        ? `${this.token.token_prefix}...`
        : '********';
    },
  },
  methods: {
    onDelete() {
      this.$emit('delete', this.token);
    },
  },
};
</script>

<template>
  <tr>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <div class="flex flex-col">
        <span class="font-medium text-n-slate-12">{{ token.name }}</span>
        <span class="text-sm text-n-slate-11 font-mono">{{ tokenPrefix }}</span>
      </div>
    </td>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <div class="flex items-center gap-2">
        <Avatar
          :src="token.kaption_assistant?.avatar_url"
          :name="token.kaption_assistant?.name"
          :size="24"
          rounded-full
        />
        <div class="flex flex-col">
          <span class="text-sm text-n-slate-12">
            {{ token.kaption_assistant?.name }}
          </span>
          <span class="text-xs text-n-slate-11">
            {{ token.kaption_assistant?.email }}
          </span>
        </div>
      </div>
    </td>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <span
        class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
        :class="statusClass"
      >
        {{ statusLabel }}
      </span>
    </td>
    <td class="py-4 ltr:pr-4 rtl:pl-4 text-sm text-n-slate-11">
      {{ lastUsedText }}
    </td>
    <td class="py-4 ltr:pr-4 rtl:pl-4 text-right">
      <NextButton
        v-if="token.status === 'active'"
        ruby
        faded
        xs
        icon="i-lucide-trash-2"
        :label="$t('KAPTION_ACCESS_TOKENS.LIST.REVOKE')"
        @click="onDelete"
      />
      <span v-else class="text-sm text-n-slate-11">
        {{ $t('KAPTION_ACCESS_TOKENS.LIST.REVOKED') }}
      </span>
    </td>
  </tr>
</template>
